import React from "react"
import { getAllCountries, getStatesByCountryId } from "../../utils"
import SelectField from "../SelectField"

class StateField extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      states: []
    }
  }

  getStates = countryName => {
    const countries = getAllCountries()
    const country = countries.find(
      country => country.name.toLowerCase() === countryName
    )
    const states =
      (country &&
        getStatesByCountryId(country.id) &&
        getStatesByCountryId(country.id).map(state => ({
          value: state.name.toLowerCase(),
          label: state.name
        }))) ||
      []
    return states
  }

  componentDidMount() {
    if (this.props.countryname) {
      this.setState(state => ({
        ...state,
        states: this.getStates(this.props.countryname)
      }))
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.countryname !== prevProps.countryname) {
      this.setState(
        state => ({
          ...state,
          states: this.getStates(this.props.countryname)
        }),
        async () => {
          const { name } = this.props.field
          const { setFieldValue } = this.props.form
          const state =
            (this.props.value &&
              this.props.value.value &&
              this.state.states.find(
                s =>
                  s.value.toLowerCase() === this.props.value.value.toLowerCase()
              )) ||
            ""
          setFieldValue(name, state || "")
          await Promise.resolve()
        }
      )
    }
  }

  render() {
    return (
      <span className="StateField">
        <SelectField
          {...this.props}
          options={
            (this.state.states.length > 0 && this.state.states) || [
              {
                value: "none",
                label: ""
              }
            ]
          }
          defaultValue={{ value: "none", label: "" }}
          isDisabled={this.props.disabled || this.state.states.length <= 0}
        />
      </span>
    )
  }
}

export default StateField
